export function PlaceReminderFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M18.5.5A4.5 4.5 0 0123 5c0 2.67-2.62 5.632-3.861 6.886a.89.89 0 01-1.278 0C16.62 10.632 14 7.67 14 5A4.5 4.5 0 0118.5.5zm1.364 7.375C20.606 6.747 21 5.743 21 5a2.5 2.5 0 00-5 0c0 .743.394 1.747 1.136 2.875.088.135.185.29.285.45.385.616.823 1.316 1.079 1.316s.694-.7 1.079-1.317c.1-.16.197-.314.285-.45zM12 2v7a5 5 0 005 5h3.414l.586.586c1.26 1.26.367 3.414-1.414 3.414H15a3 3 0 01-6 0H4.414C2.632 18 1.74 15.846 3 14.586l2.093-2.093.052-.21c.076-.302.187-.722.325-1.197.272-.93.669-2.133 1.142-3.046.43-.828 1.1-1.761 1.635-2.458.272-.355.52-.662.699-.88l.08-.097A3 3 0 0112 2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
